"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAnalyticsDataSources = void 0;
const logic_1 = require("./logic");
const addContentToAnalyticsDataSources = (analyticsDataSources, spec) => {
    //adding creativeDecisions section to analyticsDataSources.
    //adding background section to creativeDecisions.
    analyticsDataSources.creativeDecisions = analyticsDataSources.creativeDecisions ? analyticsDataSources.creativeDecisions : {};
    analyticsDataSources.creativeDecisions.background = spec.background;
    //adding ctasList section to creativeDecisions.
    if (spec.metadata && spec.metadata.interactivity && spec.metadata.interactivity.actionDefs && typeof spec.metadata.interactivity.actionDefs === "object") {
        let ctasList = Object.values(spec.metadata.interactivity.actionDefs).map((buttonObj) => {
            return { operation: buttonObj.operation };
        });
        analyticsDataSources.creativeDecisions.ctasList = ctasList;
    }
    //adding scenesLineup section to creativeDecisions.
    if (spec.lineup && Array.isArray(spec.lineup)) {
        let scenesLineup = spec.lineup.map(scene => {
            return { name: scene.name };
        });
        analyticsDataSources.creativeDecisions.scenesLineup = scenesLineup;
    }
};
const calculateAnalyticsDataSources = (analyticsDataSources, spec, context) => {
    const analyticsData = (0, logic_1.resolveTree)(analyticsDataSources, context);
    addContentToAnalyticsDataSources(analyticsData, spec);
    return analyticsData;
};
exports.calculateAnalyticsDataSources = calculateAnalyticsDataSources;
//# sourceMappingURL=analyticsDataSources.js.map